<template>
  <h1> Hi! Welcome to Btrack. Please login or create an account and link your tracker</h1>
</template>

<script>
export default {
  name: 'home',
  async created () {
    if (await this.$store.dispatch('checkAuthToken')) return this.$router.push('/dashboard')
  }
}
</script>
